import weblySleekFont from '../../../fonts/weblysleek-semilight.woff';
var fonts = "\n    @font-face {\n        font-family: 'Webly Sleek';\n        font-style: normal;\n        font-display: fallback;\n        font-weight: normal;\n        src: local('Webly Sleek'), url(".concat(weblySleekFont, ") format('woff');\n    }\n");
export var MuiCssBaseline = {
    styleOverrides: {
        fonts: fonts,
        root: { fontSize: '0.875rem' },
    },
};
